module.exports = __webpack_public_path__ + "static/media/multi.e997c4b7.jpg";